




































import { Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Model } from '@/modules/backend/Entities/Model';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import ModelAddDialog from '@/components/models/ModelAddDialog.vue';
import ModelDeleteButton from '@/components/models/ModelDeleteButton.vue';
import { DataTableHeader } from 'vuetify';
import SortMixin from '@/mixins/sort';
import Mixin from '@/mixins/base';

const ModelsModule = namespace('dashboard/models');
const ErrorsModule = namespace('app/errors');

@Component({
  mixins: [Mixin, SortMixin],
  components: {
    'model-delete-button': ModelDeleteButton,
    'model-add-dialog': ModelAddDialog,
    'data-table-wrapper': DataTableWrapper
  }
})
export default class ModelsTable extends Mixins(Mixin, SortMixin) {
  @ModelsModule.Action('Fetch')
  private ModelsFetch!: () => Promise<void>;

  @ModelsModule.Getter('Models')
  private readonly Models!: Model[];

  @ErrorsModule.Mutation('AddError')
  private AddError!: (message: string) => void;

  private loading = false;

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.isDesktop ? this.$t('common.table.headers.id').toString() : this.$t('common.table.headers.id_short').toString(),
        sortable: false,
        value: 'Id'
      },
      {
        text: this.$i18n.t('screens.models.table.headers.title').toString(),
        value: 'Model'
      },
      {
        text: this.$i18n.t('screens.models.table.headers.pulse_cost').toString(),
        value: 'PulseCost'
      },
      {
        text: this.$i18n.t('screens.models.table.headers.value_max').toString(),
        value: 'ValueMax'
      },
      {
        text: this.$i18n.t('common.table.headers.actions').toString(),
        sortable: false,
        align: 'end',
        value: 'actions'
      }
    ];
  }

  private getModalTitle(model: Model): string {
    const title = model.getName();
    if (title) {
      return title;
    }

    return '—';
  }

  private getModalPulseCost(model: Model): number {
    const pulseCost = model.getPulseCost();
    if (pulseCost) {
      return pulseCost;
    }

    return 0;
  }

  private getModalValueMax(model: Model): number {
    const valueMax = model.getValueMax();
    if (valueMax) {
      return valueMax;
    }

    return 0;
  }

  private customSort(items: Model[], index: string[], isDescending: boolean[]): Model[] {
    items.sort((a, b): number => {
      if (index[0] === 'Model') {
        return this.stringComparator(
          this.getModalTitle(a),
          this.getModalTitle(b),
          isDescending[0]
        );
      }

      if (index[0] === 'PulseCost') {
        return this.numberComparator(
          this.getModalPulseCost(a),
          this.getModalPulseCost(b),
          isDescending[0]
        );
      }

      if (index[0] === 'ValueMax') {
        return this.numberComparator(
          this.getModalValueMax(a),
          this.getModalValueMax(b),
          isDescending[0]
        );
      }

      return 0;
    });

    return items;
  }

  private async loadData(): Promise<void> {
    this.loading = true;
    await this.ModelsFetch();
    this.loading = false;
  }

  public async mounted(): Promise<void> {
    await this.loadData();
  }
}
